import cn from 'classnames'
import { useCallback } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { Tooltip } from 'core-components/library/tooltip'
import { TRANSLATION_KEYS } from 'partner360/components/QBR/translations'

import styles from './Attachment.module.scss'

interface IAttachment {
  link: string
  text: string
  onDelete: () => void
  isFile?: boolean
  isDisabled?: boolean
  className?: string
}
export const Attachment = ({
  isDisabled,
  isFile,
  link,
  text,
  className,
  onDelete,
}: IAttachment) => {
  const renderTip = useCallback(
    () => <Translation text={TRANSLATION_KEYS.reportIssueModal.deleteAttachment} span />,
    []
  )
  return (
    <div className={cn(styles.link, className)} key={link}>
      <a
        className={styles.linkValue}
        download={isFile && text}
        href={link}
        rel="noreferrer"
        target="_blank"
      >
        {text}
      </a>
      <Tooltip tipContent={renderTip}>
        <Button
          className={styles.deleteLinkBtn}
          color="danger"
          variant="text"
          iconButton="kbase kbase-delete"
          onClick={onDelete}
          disabled={isDisabled}
        />
      </Tooltip>
    </div>
  )
}
